import React, { lazy, Suspense } from 'react';
import { usePage } from 'effects/usePage';
import LoadingScreen from 'components/Progress/LoadingScreen';

const DescriptionHelper = lazy(() => import('components/Layout/DescriptionHelper' /* webpackChunkName: "descriptionHelper" */));

interface DynamicPageProps {
  handle: string;
}

const DynamicPage: React.FC<DynamicPageProps> = ({ handle }) => {
  const page = usePage(handle);
  if (!page) return <LoadingScreen />;
  return <Suspense fallback={<LoadingScreen />}>{page && <DescriptionHelper html={page.body_html} />}</Suspense>;
};

export default DynamicPage;
